<button
  class="btn btn-secondary"
  type="button"
  (click)="onClick()">
  {{ 'APPLICATION.FORM.cancel' | translate }}
</button>
